import { useEffect, useState } from "react";
import { Circle, MapContainer, Marker, Popup, TileLayer } from "react-leaflet";
import hospitalData from "../resources/Bangalore_Data.json";
import Mycomponent from "./Mycomponent.js";
import { Icon } from "leaflet";
// let module = require("../data.js");
const Green = new Icon({
  iconUrl:
    "https://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=%E2%80%A2|ff3c00&chf=a,s,ee00FFFF",
  iconAnchor: [10, 33],
  popupAnchor: [0, -34],
});
const Blueicon = new Icon({
  iconUrl:
    "https://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=%E2%80%A2|abcdef&chf=a,s,ee00FFFF",
  iconAnchor: [10, 33],
  popupAnchor: [0, -34],
});

function Map() {
  const [nearestInd, setnearestInd] = useState("");
  const [distance, setdistance] = useState(0);
  const [constdistance, setconstdistance] = useState(0);
  const [intId, setintId] = useState("");
  // let data = module.dataArr;
  let data = hospitalData;
  function getnearhospital(arr_index) {
    setnearestInd(arr_index[0]);
    setdistance(0);
    setconstdistance(arr_index[1]);
    let id = increasingrad(arr_index[1]);
    setintId(id);
    if (arr_index[1] !== distance) {
      // console.log(distance);
      clearInterval(intId);
    }
  }
  function increasingrad(dist) {
    let start = 1;
    let ininterval = setInterval(() => {
      if (start > 69) {
        start = 1;
      } else {
        start += 1;
        setdistance(0 + (dist * start) / 71);
      }
    }, 14);
    return ininterval;
  }

  return (
    <>
      <MapContainer center={[12.9716, 77.5946]} zoom={12}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {/* <Marker position={[newLatLng.lat, newLatLng.lng]}></Marker> */}
        {data.map((hospital, index) => {
          return (
            <div key={index}>
              {index === nearestInd ? (
                <>
                  <Marker icon={Green} position={[hospital.Lat, hospital.Lng]}>
                    <Popup>
                      <h4>{hospital["Hospital Names"].split(",")[0]}</h4>
                      <p className="address">
                        {hospital["Hospital Names"].split(",").slice(1)}
                      </p>
                    </Popup>
                  </Marker>
                  {/* uncomment to add circle */}
                  <Circle
                    center={[hospital.Lat, hospital.Lng]}
                    radius={constdistance * 1000}
                    color={"red"}
                    stroke={false}
                    weight={1}
                    fillOpacity={0.2}
                  ></Circle>
                  {/* uncomment to add moving circle */}
                  <Circle
                    center={[hospital.Lat, hospital.Lng]}
                    radius={distance * 1000}
                    color={"red"}
                    // stroke={false}
                    weight={1}
                    opacity={0.5}
                    fillOpacity={0.1}
                  ></Circle>
                </>
              ) : (
                <Marker
                  icon={Blueicon}
                  key={index}
                  position={[hospital.Lat, hospital.Lng]}
                >
                  <Popup>
                    <h4>{hospital["Hospital Names"].split(",")[0]}</h4>
                    <p className="address">
                      {hospital["Hospital Names"].split(",").slice(1)}
                    </p>
                  </Popup>
                </Marker>
              )}
            </div>
          );
        })}
        <Mycomponent
          parentcallback={getnearhospital}
          // newMarker={Addnewmarker}
        />
      </MapContainer>
    </>
  );
}

export default Map;

// function NewMarker(props) {
//   let { hospital } = props;
//   return (
//     <Marker icon={Green} position={[hospital.Lat, hospital.Lng]}>
//       <Popup>
//         <h4>{hospital.Hospital_Names.split(",")[0]}</h4>
//         <p className="address">{hospital.Hospital_Names.split(",").slice(1)}</p>
//       </Popup>
//     </Marker>
//   );
// }
